<template>
    <!-- Loading -->
    <div class="vld-parent">
        <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128" />
    </div>

    <form @submit.prevent="store" class="form-content">
        <div class="form-content-inner">
            <div class="form-col">
                <control type="hidden" v-model="certification.id" :hasError="!!errors.id" id="id"/>
            </div>
            <div class="form-col">
                <field :label="'Certification Name'" class="w-full md:w-2/2 px-3 mb-1 md:mb-0">
                    <control type="text" v-model="certification.certificate"/>
                </field>
            </div>
            <div class="form-col">
                <field :label="$t('certification.institution')" class="w-full md:w-2/2 px-3 mb-1 md:mb-0">
                    <control type="text" v-model="certification.institute"/>
                </field>
            </div>
            <div class="form-col">
                <field :label="$t('vaccines.description')" class="w-full md:w-2/2 px-3 mb-1 md:mb-0">
                    <control type="text" v-model="certification.remarks"/>
                </field>
            </div>
            <div class="form-col">
                <field :label="'Expired Date'" class="w-full md:w-2/2 px-3 mb-1 md:mb-0">
                    <datepicker v-model="certification.expired_date" :enableTimePicker="false" name="expired_date" :auto-apply="true"></datepicker>
                </field>
            </div>
            <!-- <control type="number" v-model="certification.year"/> -->
            <div class="form-col">
                <field :label="$t('lessonplan.file')" class="w-full md:w-2/2 px-3 mb-1 md:mb-0">
                    <input type="file" accept="application/pdf" v-on:change="onFileChange" class="form-control-file" id="my-file">
                </field>
            </div>
            <div class="buttons-submit transition-colors duration-1000" :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'">
                <jb-buttons class="buttons-action-submit">
                    <jb-button type="submit" color="info" :icon="mdiCheckBold" :label="$t('finance.button.btnSubmit')" class="form-submit-btn" />
                    <jb-button type="button" color="info" outline :label="$t('finance.button.btnReset')" class="form-noicon-btn btn-reset" @click="reset()" />
                </jb-buttons>
            </div>
        </div>
    </form>
</template>
<script>
/* eslint-disable */
import { ref, reactive, onMounted, onBeforeMount, watch, watchEffect } from 'vue'
import { axiosDocument } from "@/boot/axios";
import axios from 'axios'
import { mdiBallot, mdiCheckBold } from '@mdi/js'
import { useStore } from 'vuex'
import Control from '@/components/Control'
import { useRouter } from 'vue-router'
import JbButton from '@/components/JbButton'
import JbButtons from '@/components/JbButtons'
import Field from '@/components/Field'
import { useToast } from 'vue-toastification'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main\.css'
import Loading from 'vue-loading-overlay'
export default {
    name: 'ClassForm',
    components: {
        Field,
        Datepicker,
        Control,
        JbButton,
        JbButtons,
        Loading
    },
    props: {
        showEdit: { Boolean },
        propClass: {
            type: Object,
            default: () => ({ empty: true })
        },
        propObject: {
            type: Object,
            default: () => ({ empty: true })
        },
        
    },
    data: function () {
        return {
        }
    },
    emits: ['close-modal', 'submit', 'refresh-list'],
    setup (props, { emit }) {
        const titleStack = ref(['Admin', 'Forms'])
        const isLoading = ref(false)

        const toast = useToast()

        const router = useRouter()

        const errors = ref([])
        const options = ['ID Card', 'Family Card', 'Passport', 'TIN']
        const preview = ref('')

        const str = useStore()
        const userlogin = localStorage.getItem('name')

        const certification = reactive({
            id: '',
            certificate: '',
            institute: '',
            expired_date: '',
            remarks: '',
            year: '',
            created_by: '',
            updated_by: ''
        })

        const customElementsForm = reactive({
            checkbox: ['lorem'],
            radio: 'one',
            is_active: [1],
            file: null
        })

        const resetForm = () => {
            certification.id = ''
            certification.certificate = ''
            certification.institute = ''
            certification.expired_date = ''
            certification.remarks = ''
            certification.year = ''
        }

        const onFileChange = async (event, evt) => {
            const file = event.target.files[0]
            if (file) {
                if (file.type !== 'application/pdf') {
                    alert('Only PDF files are allowed');
                    event.target.value = ''
                }
                else if (file.size > 1024 * 1024) {
                    alert('File too big (> 1MB)')
                    file.value = ''
                } else {
                    const reader = new FileReader()
                    reader.onloadend = function () {
                        preview.value = reader.result
                }
                reader.readAsDataURL(file)
                }
            } else {
                preview.value = ''
            }
        }

        const store = async () => {
            isLoading.value = true
            const url = props.showEdit ? 'certification/' + certification.id : 'certification';
            const method = props.showEdit ? "PUT" : "POST";
            certification.created_by = userlogin
            certification.file = preview.value

            const jsonData = JSON.stringify(certification)

            const configHeaders = {
                "content-type": "application/json",
                "Accept": "application/json"
            };

            await axios({
                    method,
                    url,
                    data: jsonData,
                    headers: configHeaders
                })
                .then(response => {
                    if(response.data.is_doc > 0){
                        storeDoc(response.data.link_doc)
                    } else {
                        if (response.data.success) {
                            emit('close-modal')
                            emit('refresh-list')
                            resetForm()
                            toast.success(response.data.message)
                        } else {
                            errors.value = response.data.messages
                            toast.error(response.data.messages)
                        }
                        // console.log(errors.value)
                        isLoading.value = false
                    }
                })
                .catch(error => {
                    if (error.response) {
                        console.log(error)
                        toast.error(error.response.data.message)
                        console.log(JSON.stringify(error.request))
                    } else if (error.message) {
                        console.log(error.message)
                        toast.error(error.message)
                        console.log(JSON.stringify(error.message))
                    }
                    isLoading.value = false
                })
        }

        // if doc academic active = true
        const storeDoc = (env) => {
            const url = 'doc-file-employee'
            const method = 'POST'

            isLoading.value = true
            const paramsData = {
                link_doc: env
            }
            const jsonData = JSON.stringify(paramsData)
            console.log('paramsData DOC', paramsData)

            const configHeaders = {
                'content-type': 'application/json',
                Accept: 'application/json'
            }

            axiosDocument({
                method,
                url,
                data: jsonData,
                headers: configHeaders
            })
            .then(response => {
                isLoading.value = false
                emit('close-modal')
                emit('refresh-list')
                resetForm()
                toast.success(response.data.message)
            })
            .catch(error => {
                isLoading.value = false
                console.log('error', error)
            })
        }

        onBeforeMount(() => {
        })

        onMounted(() => {
            // certification.value =toRefs(props, 'propClass')
        })

        watch(() => props.propClass, (newVal, oldVal) => {
            certification.file = ''
            certification.description = ''
        })

        watchEffect(() => {
            const newobject = props.propObject
            Object.assign(certification, newobject)
            
            const newcertification = props.propClass
            certification.submenu = newcertification.submenu
            certification.ein = newcertification.ein
            certification.employee_id = newcertification.employee_id
            certification.nickname = newcertification.nickname
        })

        return {
            titleStack,
            onFileChange,
            customElementsForm,
            mdiBallot,
            mdiCheckBold,
            options,
            router,
            certification,
            store,
            toast,
            userlogin,
            errors,
            isLoading,
            resetForm,
        }
    },
    methods: {
        // async store () {
        //     const dataForm = {
        //         id: this.certification.id,
        //         name: this.certification.name,
        //         academic_year_id: this.certification.academic_year_id,
        //         capacity: this.certification.capacity,
        //         homeroom_id: this.certification.homeroom_id ?? this.certification.level_id,
        //         is_active: this.customElementsForm.is_active ?? false,
        //         remarks: this.certification.remarks,
        //         level_id: this.certification.level_id,
        //         department_id: this.certification.department_id,
        //         remarks1: this.certification.remarks1,
        //         remarks2: this.certification.remarks2,
        //         remarks3: this.certification.remarks3,
        //         created_by: 'admin',
        //         updated_by: this.certification.updated_by
        //     }
        //     // await axios
        //     //     .post('class', dataForm)
        //     //     .then(response => {
        //     //         if (response.data.success) {
        //     //         } else {
        //     //             this.errors = response.data.messages
        //     //         }
        //     //     })
        //     //     .catch(error => {
        //     //         if (error.response) {
        //     //             console.log(error)
        //     //             console.log(JSON.stringify(error.request))
        //     //         } else if (error.message) {
        //     //             console.log(error.message)
        //     //             console.log(JSON.stringify(error.message))
        //     //         }
        //     //     })
        // },
        clearForm () {
            this.certification = reactive({
                id: '',
                description: '',
                created_by: ''
            })
        },
        onChange: function (department_id, event) {
            if (event.target.value) {
                department_id = event.target.value
            }
            this.levelListFilter = this.levelList.filter(item => item.department_id === department_id)
            this.academicYearListFilter = this.academicYearList.filter(item => item.department_id === department_id)
        }
    },
    created () {
        this.levelListFilter = this.levelList
        this.academicYearListFilter = this.academicYearList
    }
}
</script>
